import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import { AppService } from 'src/app/services/app.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-new-email-page',
  templateUrl: './new-email-page.component.html',
  styleUrls: ['./new-email-page.component.scss']
})
export class NewEmailPageComponent implements OnInit {
  public email: string;
  public status: 'PENDING' | 'VALIDATING' = 'PENDING';
  public emailNotFound = false;

  public emailFormControl: FormControl;
  public emailFormSubscription: Subscription;

  constructor(private app: AppService) {
    this.app.isAuthed((auth: boolean) => {
      if (!auth) {
        this.app.router.navigateByUrl('');
      }
    });
  }

  ngOnInit(): void {
    this.emailFormControl = new FormControl(this.email, [
      Validators.required,
      Validators.email,
      (c: AbstractControl) => {
        if (!this.emailNotFound) {
          return null;
        } else {
          return {
            found: {
              valid: false
            }
          };
        }
      }
    ]);
  }

  public onSubmit(): void {
    this.app.dialog.loader({ title: 'Fordere E-Mail-Validierung an' });
    // this.status = 'VALIDATING';
    this.emailFormControl.updateValueAndValidity();
    this.email = this.emailFormControl.value;
    this.app.newEmail(this.email).then(() => {
      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.app.router.navigateByUrl('neue-email/angefordert', {
          params: {
            type: 'EMAIL_REQUEST',
            email: this.email
          }
        });
      }, 500);
    }).catch(() => {
      this.app.toast.open('Unbekannter Fehler', null, {
        panelClass: 'warn'
      });
      setTimeout(() => {
        this.app.dialog.closeLoader();
        this.emailNotFound = true;
        this.emailFormControl.markAllAsTouched();
        this.emailFormControl.markAsDirty();
        this.emailFormControl.updateValueAndValidity();
        this.status = 'PENDING';
        this.emailFormSubscription = this.emailFormControl.valueChanges.subscribe(() => {
          this.emailNotFound = false;
          this.emailFormControl.markAsPristine();
          this.emailFormSubscription.unsubscribe();
        });
      }, 500);
    });
  }





}
